module.exports = __webpack_public_path__ + "img/cta.386e0fa9.png";